module.exports = __webpack_public_path__ + "static/media/Llibre_obert_BLAU.d2820702.svg";